import { Field, FieldProps } from 'formik'
import React from 'react'
import styled from 'styled-components'
import { addErrorDataAttribute } from './utils'
import { DatePicker } from '../ui/form/DatePicker'
import { FormFeedback } from '../ui/form/FormFeedback'
import { Label } from '../ui/form/Label'

interface Props {
  name: string
  label?: string
  labelColor?: string
  required?: boolean
}

export const SmartDatePicker: React.FC<Props> = ({
  name,
  label,
  labelColor,
  required,
}) => {
  return (
    <Field name={name}>
      {({ field, form, meta }: FieldProps) => (
        <div>
          {label && (
            <Label htmlFor={name} color={labelColor}>
              {label} {required ? <RequiredSpan> * </RequiredSpan> : null}
            </Label>
          )}
          <DatePicker
            value={field.value}
            onChange={date => {
              form.setFieldValue(field.name, date)
            }}
            {...addErrorDataAttribute(meta)}
          />
          {meta.error && meta.touched && (
            <FormFeedback variant='error'>{meta.error}</FormFeedback>
          )}{' '}
        </div>
      )}
    </Field>
  )
}

const RequiredSpan = styled.span`
  dcolor: ${({ theme }) => theme.color.secondari.arancioneScuro};
`
